import { Show } from "solid-js";
import { runtimeConfig } from "../config";
import { authRequest } from "../core/api";

const authErrors: Record<string, string> = {
  character_service_unavailable:
    "The game character service is temporarily unavailable. Please try again.",
  invalid_steam_id: "Steam did not return a valid account.",
  missing_openid_payload: "Steam login response is incomplete.",
  no_authorized_characters:
    "No authorized MDT character was found for this Steam account.",
};

function LaptopGraphic() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="191"
      height="159"
      viewBox="0 0 191 159"
      fill="none"
      class="h-64 w-64 pb-4"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.0896 1.2422C23.7876 1.92496 21.9975 3.5072 21.1113 4.75795L19.5 7.03149L19.3577 56.6309L19.2153 106.23H95.4992H171.783L171.641 56.6309L171.498 7.03149L169.887 4.75795C169.001 3.5072 167.211 1.92496 165.909 1.2422L163.541 0H95.4992H27.4571L25.0896 1.2422ZM159.11 12.5864C159.87 13.3407 159.943 17.6257 159.82 53.8081L159.682 94.1879L158.34 94.8632C157.28 95.3959 144.013 95.5385 95.4992 95.5385C46.9854 95.5385 33.718 95.3959 32.6589 94.8632L31.3161 94.1879L31.1786 53.8081C31.0551 17.6257 31.1287 13.3407 31.8881 12.5864C32.6503 11.8289 39.0519 11.7441 95.4992 11.7441C151.946 11.7441 158.348 11.8289 159.11 12.5864ZM11.1116 122.112C5.02149 132.621 5.00215 132.666 5 136.163C4.99785 140.178 6.2074 142.487 9.47617 144.714L11.3646 146H95.4992H179.634L181.522 144.714C184.79 142.489 186 140.178 186 136.163C186 132.663 185.985 132.629 179.88 122.112L173.76 111.569H95.4906H17.2211L11.1116 122.112ZM108.62 134.294C109.751 135.419 109.683 136.44 108.39 137.726C107.38 138.729 106.599 138.793 95.4992 138.793C84.399 138.793 83.6181 138.729 82.6089 137.726C81.3155 136.44 81.2473 135.419 82.3785 134.294C83.0966 133.581 85.0548 133.455 95.4992 133.455C105.944 133.455 107.902 133.581 108.62 134.294Z"
        fill="url(#mdt-login-laptop)"
        fill-opacity="0.25"
      />
      <defs>
        <radialGradient
          id="mdt-login-laptop"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(95.5 73) rotate(90) scale(98.8017 122.487)"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export function LoginView() {
  const authErrorCode = new URLSearchParams(window.location.search).get(
    "authError",
  );
  const authError = authErrorCode
    ? authErrors[authErrorCode] ?? "Steam login could not be completed."
    : null;

  const steamLogin = async () => {
    try {
      const url = await authRequest<string>("external-auth");
      window.open(url);
    } catch (reason) {
      console.error("Error to get login link", reason);
    }
  };

  return (
    <main class="dump-root flex h-screen w-full items-center justify-center px-14">
      <section class="flex flex-col items-center justify-start">
        <div class="flex flex-col items-center py-12">
          <img
            class="h-24 w-24 object-contain"
            style="filter:drop-shadow(2rem 0rem 4rem #08f8bb) drop-shadow(-2rem 0px 4rem #6c63e0)"
            src={`${runtimeConfig.assetOrigin}/logo.png`}
            alt=""
          />
          <p class="roboto700 text-center text-4xl text-white">nopixel</p>
          <p class="roboto400 text-center text-xl text-white">
            MDT PANEL LOG-IN
          </p>
        </div>

        <LaptopGraphic />

        <p class="roboto400 w-1/3 text-center text-lg leading-8 text-gray-400">
          To access the Mobile Data Terminal (MDT), users can simply log in
          using their credentials. The MDT provides real-time access to
          critical data, enabling efficient communication and decision-making
          for mobile operations, such as emergency services, transportation,
          and field work.
        </p>

        <button
          class="center font-2xl mt-12 bg-nopixel-dark px-12 py-2 hover:bg-nopixel-light"
          onClick={steamLogin}
        >
          <p class="roboto400 text-white">Login via steam</p>
        </button>
        <Show when={authError}>
          {(message) => (
            <p class="roboto400 mt-3 max-w-lg text-center text-red-400">
              {message()}
            </p>
          )}
        </Show>
      </section>
    </main>
  );
}
